export const portfolio_fundamentals = `query portfolio_fundamentals($account: String!){
  portfolio_fundamentals(account: $account){
      name
      reserved
      investable
      payable
      market_price
      exchange_rate
      value
      percent
      accounts{
        type
        number
      }
      ... on PortfolioFinancialInstrument{
        last_closing_price
        count
        security_type
        type
        tradable_stock_exchange
        security{
          short_name
          name
          stock_market_locality
          currency{
              currency
              name
              decimal
          }
        }
      }
      ... on PortfolioFunds{
        balance
      }
  }
}`;
